import React from 'react';
import classnames from 'classnames';

const UndoUnitHolder = ({ calendarType, onClick }) => (
  <div className={classnames('unit-holder')}>
    <div className="unit-container">
      <button
        type="button"
        className="unit unit--add"
        onClick={() => onClick(calendarType)}
      >
        <div className="unit--undo" />
        <h3>Undo</h3>
      </button>
    </div>
  </div>
);

export default UndoUnitHolder;
